import { getFeatureData } from 'config-request';
import { CategoryCode, FeatureType, SubCategoryCode, } from 'config-request/src/interfaces/feature-list';
import { defineStore } from 'pinia';
import { useOptionImageStore } from './option-image';
import { useFeatureListStore } from './feature-list';
import { usePriceListStore } from './price-list';
export const useOptionalStore = defineStore('optional', {
    state() {
        return {
            optionImgMap: {},
        };
    },
    getters: {
        /**
         * 选配列表
         */
        optionalList() {
            const featureListStore = useFeatureListStore();
            const optionImageStore = useOptionImageStore();
            const priceList = usePriceListStore();
            if (!featureListStore.data)
                return [];
            const optionalCodeList = [
                CategoryCode.Optional,
                SubCategoryCode.SubOptional,
                FeatureType.SubOptional,
            ];
            const featureItem = getFeatureData(optionalCodeList, featureListStore.data);
            return featureItem?.option_list?.map((option) => {
                const item = featureListStore.data?.option_map[option];
                const priceDiscountTip = priceList.data?.configurator_select_discount_tip_map?.[option] || '';
                const priceDiscountTipIcon = priceList.data?.configurator_select_discount_tip_icon_map?.[option] || {
                    icon: '',
                    icon_ratio: 0,
                };
                const discountData = {
                    discount_selected: !!priceDiscountTip,
                    discount_tip: priceDiscountTip || item?.discount_tip || '',
                    discount_tip_icon: priceDiscountTipIcon?.icon || item?.discount_tip_icon || '',
                    discount_tip_icon_ratio: priceDiscountTipIcon?.icon_ratio || item?.discount_tip_icon_ratio || 0,
                };
                const material = optionImageStore.commonImgs(SubCategoryCode.SubOptional, item?.code ?? '')?.[0];
                // let img = ''
                // 如果是对象的话
                // if (typeof material === 'object') {
                //   if (material.type === 'video') {
                //     img = material.img
                //   } else {
                //     img = material.material
                //   }
                // }
                if (item?.code) {
                    this.optionImgMap[item?.code] = material;
                }
                return {
                    ...item,
                    imgSrc: material,
                    ...discountData,
                };
            });
        },
    },
});
